module.exports = __webpack_public_path__ + "static/media/guide_book.8f6aa7e0.png";